module.exports = ".info-block {\n    background-color: white;\n    margin-left: -20px;\n    margin-right: -20px;\n    margin-top: -10px;\n}\n\n/deep/ .about-main-view .dx-popup-content{\n    background-color: #efefef;\n}\n\n.title-text {\n    text-align: center;\n    font-size:14px;\n    font-weight: bold;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.confirm-btn {\n    margin-left: 650px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/custom/about-view/about-view.component.css
// module id = ./src/app/components/custom/about-view/about-view.component.css
// module chunks = main